
export async function listUsers() {
  try {
    const response = await fetch("https://hs2api.razamit.pl/manager-users", {
      credentials: 'include',
    });
    if (!response.ok) throw new Error(`Błąd: ${response.status}`);
    const data = await response.json();
    return data.users || [];
  } catch (err) {
    console.error("Błąd pobierania danych:", err);
    return [];
  }

}

export async function createUser(payload) {
  try {
    const response = await fetch("https://hs2api.razamit.pl/manager-users", {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Błąd API (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Błąd tworzenia użytkownika:", err);
    throw err;
  }
}

export async function updateUser(id, patch) {
  try {
  
    const res = await fetch(`https://hs2api.razamit.pl/manager-users?id=${id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patch),
    });

    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.error || 'Błąd podczas aktualizacji użytkownika');
    }

    return await res.json(); // { success: true, message: '...' }
  } catch (error) {
    console.error('updateUser error:', error);
    throw error;
  }
}

export async function deleteUser(id) {
  try {
    const res = await fetch(`https://hs2api.razamit.pl/manager-users?id=${id}`, {
      method: 'DELETE',
      credentials: 'include',
    });

    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.error || 'Błąd podczas usuwania użytkownika');
    }

    return await res.json(); // { success: true, message: '...' }
  } catch (error) {
    console.error('deleteUser error:', error);
    throw error;
  }
}

export async function SendEmail(id) {
  try {
    const res = await fetch(`https://hs2api.razamit.pl/manager-users-dataSend?id=${id}`, {
      method: 'PUT',
      credentials: 'include', 
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.error || 'Błąd podczas wysyłania danych do użytkownika');
    }

    return await res.json(); // { success: true, message: '...' }
  } catch (error) {
    console.error('Wysyłania danych użytkownikowi error:', error);
    throw error;
  }
}
 


